import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=4fb8966f&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb8966f')) {
      api.createRecord('4fb8966f', component.options)
    } else {
      api.reload('4fb8966f', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=4fb8966f&", function () {
      api.rerender('4fb8966f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/slider/slider.vue"
export default component.exports